export interface UmpireStaffRole {
  type: 'staff_role';
  name: string;
  id: string;
}
